module.exports = __webpack_public_path__ + "static/img/salesHome_solve1.20fb447.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/salesHome_solve1.svg
// module id = bQcj
// module chunks = 1